import { FC, ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'src/components';
import * as S from './styles';

const msgs = defineMessages({
  audio: { id: 'learning_session_learnables_card_audio' },
});

type AudioPanelProps = {
  src: string | null;
  autoPlay: boolean;
  rail?: ReactNode;
  dark?: boolean;
  onPlay?: () => void;
};

export const AudioPanel: FC<AudioPanelProps> = ({ src, autoPlay, rail, dark = false, onPlay }) => {
  const intl = useIntl();

  return (
    <S.Panel $dark={dark} data-testid="blob-audio-panel">
      {src ? (
        <S.Speaker
          src={src}
          ariaText={intl.formatMessage(msgs.audio)}
          autoPlay={autoPlay}
          playOnKeyboardShortcut
          larger
          onClick={onPlay}
        />
      ) : (
        <S.SilentSpeaker $dark={dark} aria-hidden data-testid="blob-audio-placeholder">
          <Icon name="soundFull" />
        </S.SilentSpeaker>
      )}
      {rail}
    </S.Panel>
  );
};
